import React, { useState } from 'react';
import './ListProperty.css';
import { useNavigate } from 'react-router-dom';
import { useContext, useEffect } from 'react'
import { DAppContext } from '../../context/DAppContext'
import RealEstate from '../../abis/RealEstate.json'
import Investment from '../../abis/Investment.json'
import config from '../../config.json';
import { ethers } from 'ethers';
import { Web3Storage } from 'web3.storage';

import Web3 from 'web3';



const tokens = (n) => {
    return ethers.utils.parseUnits(n.toString(), 'ether')
}

function makeStorageClient() {
    return new Web3Storage({ token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweGNCOTk0OTY1MWNkQTk5YzYzM2U0QjFEMzgxMmIyNTQzMTlEYzgwQjAiLCJpc3MiOiJ3ZWIzLXN0b3JhZ2UiLCJpYXQiOjE2ODUzNjAwNzQyMzQsIm5hbWUiOiJQcm9wU2hhcmUifQ.nPYnkscXGYZH5hTtAN-hG6YGyIjcfyY3yCI58nWKI2k" })
}


const ListProperty = () => {
    const web3 = new Web3();

    const [property, setProperty] = useState({
        name: '',
        address: '',
        description: '',
        image: '',
        id: '',
        share_percent: '',
        property_name: '',
        property_symbol: '',
        attributes: [
            { trait_type: 'Purchase Price', value: '' },
            { trait_type: 'Type of Residence', value: '' },
            { trait_type: 'Bed Rooms', value: '' },
            { trait_type: 'Bathrooms', value: '' },
            { trait_type: 'Square Feet', value: '' },
            { trait_type: 'Year Built', value: '' },
        ],
    });

    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);

    const [provider, setProvider] = useState(null)
    const [account, setAccount] = useState(null)

    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "image") {
            const file = e.target.files[0];
            setImageFile(file);
            setImagePreview(URL.createObjectURL(file));
        } else {
            setProperty((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        const imageClient = makeStorageClient();
        // console.log(property)
        const imgF = new File([imageFile], "image.png")
        const imageCid = await imageClient.put([imgF], "yes.png");

        console.log(imageCid)
        setProperty((prevState) => ({
            ...prevState,
            image: "https://${imageCid}.ipfs.w3s.link/image.png",
        }));

        await new Promise((resolve) => setTimeout(resolve, 0));

        const jsonData = JSON.stringify(property);
        console.log(jsonData)

        const file = new Blob([jsonData], { type: 'application/json' });
        const jsonFile = new File([file], "metadata.json")
        const client = makeStorageClient()
        const cid = await client.put([jsonFile], "whynot.json")
        // console.log('stored files with cid:', cid)

        //minting
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        const account = ethers.utils.getAddress(accounts[0])
        setAccount(account)
        console.log(account)

        const cidUrl = "https://" + cid + ".ipfs.w3s.link/metadata.json"

        const provider = new ethers.providers.Web3Provider(window.ethereum)
        setProvider(provider)
        const network = await provider.getNetwork()

        const realEstate = new ethers.Contract(config[network.chainId].realEstate.address, RealEstate, provider)

        const investment = new ethers.Contract(config[network.chainId].investment.address, Investment, provider)
        console.log(investment)

        const signer = provider.getSigner(account);
        const mintTx = await realEstate.connect(signer).mint(cidUrl)
        const receipt = await mintTx.wait();
        const [transferEvent] = receipt.events;
        let { tokenId } = transferEvent.args;
        tokenId = web3.utils.fromWei(tokenId.toString(), 'ether') * 10 ** 18;
        // const id = receipt.events[0].args.newItemId.toNumber();
        // console.log(receipt)
        // console.log(tokenId)
        // console.log(id)

        let transaction = await realEstate.connect(signer).approve(investment.address, tokenId)
        await transaction.wait()

        transaction = await investment.connect(signer).list(tokenId, tokens(property.attributes[0].value), property.share_percent, property.property_name, "WASH", account)
        await transaction.wait()

        // console.log(id)

        setLoading(false)

        if (window.confirm('Your property is listed. Please wait for the inspector\'s approval')) {
            navigate('/');
        }
    };

    return (
        <div className="ListProperty">
            <h2>List Property</h2>
            {loading && (
                <div className="loading-overlay">
                    <div className="spinner"></div>
                </div>
            )}

            <form onSubmit={handleSubmit}>
                <div className='form_container'>
                    <div className='form_left'>
                        <label htmlFor="name">Name:</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            //   value={property.name}
                            onChange={handleInputChange}
                        />
                        <label htmlFor="share">Share of property:</label>
                        <input
                            type="number"
                            id="share"
                            name="share_percent"
                            value={property.share_percent}
                            onChange={handleInputChange}
                        />

                        <label htmlFor="address">Address:</label>
                        <input
                            type="text"
                            id="address"
                            name="address"
                            value={property.address}
                            onChange={handleInputChange}
                        />

                        <label htmlFor="description">Description:</label>
                        <textarea
                            id="description"
                            name="description"
                            value={property.description}
                            onChange={handleInputChange}
                        ></textarea>

                        <label htmlFor="image">Image URL:</label>
                        <input
                            type="file"
                            id="image"
                            name="image"
                            //   accept="image/*"
                            //   value={property.image}
                            onChange={handleInputChange}
                        />
                        {imagePreview && (
                            <img src={imagePreview} alt="Preview" style={{ width: '200px' }} />
                        )}
                    </div>
                    <div className='form_right'>
                        {/* Render other input fields for the attributes array */}
                        {property.attributes.map((attribute, index) => (
                            <div key={index}>
                                <label htmlFor={attribute.trait_type}>{attribute.trait_type}:</label>
                                <input
                                    type={attribute.trait_type === 'Type of Residence' ? 'text' : 'number'}
                                    id={attribute.trait_type}
                                    name={attribute.trait_type}
                                    value={attribute.value}
                                    onChange={(e) => {
                                        const { name, value } = e.target;
                                        setProperty((prevState) => ({
                                            ...prevState,
                                            attributes: prevState.attributes.map((attr, idx) =>
                                                idx === index ? { ...attr, value } : attr
                                            ),
                                        }));
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                </div>
                <button type="submit">Submit</button>
            </form>
        </div>
    );
};

export default ListProperty;

